/*
 * Copyright (c) 2023. Collabro Limited
 */
import React, { useEffect, useRef, useState } from "react";
import { PopoutScreenProps } from "../Options/Options";
import {
  Divider,
  IconButton,
  Popover,
  Slide,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import SingleBooking from "./SingleBooking";
import BulkBooking from "./BulkBooking";

const BookingsScreen = (props: PopoutScreenProps) => {
  const [isBulk, setIsBulk] = useState(false);

  const handleClose = () => {
    props.onClose(null);
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsBulk(event.target.checked);
  };

  return (
    <Popover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <div
        style={{
          padding: 10,
          width: 400,
          height: "100%",
        }}
      >
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
        <Divider>
          <Typography variant="h6">Create Booking</Typography>
        </Divider>
        <Stack
          sx={{ width: "100%" }}
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="center"
        >
          <Typography>Single</Typography>
          <Switch checked={isBulk} onChange={handleSwitchChange} />
          <Typography>Bulk</Typography>
        </Stack>
        <div style={{ position: "relative", height: 530 }}>
          <Slide direction="right" in={!isBulk} mountOnEnter unmountOnExit>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
              }}
            >
              <SingleBooking close={handleClose} />
            </div>
          </Slide>
          {/* Bulk Component */}
          <Slide direction="left" in={isBulk} mountOnEnter unmountOnExit>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
              }}
            >
              <BulkBooking />
            </div>
          </Slide>
        </div>
      </div>
    </Popover>
  );
};

export default BookingsScreen;
